// extracted by mini-css-extract-plugin
module.exports = {"base":"dropdown_base__D6TVt","hamburgerContainer":"dropdown_hamburgerContainer__fJ89o","open":"dropdown_open__2qO5V","menuList":"dropdown_menuList__2MI0g"};